/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'

icon.register({
  'user': {
    width: 250,
    height: 250,
    viewBox: '0 0 1024 1024',
    data: '<path pid="0" d="M288.35699999999997 287.791a223.922 223.922 0 10447.844 0 223.922 223.922 0 10-447.844 0z"/><path pid="1" d="M512.279 511.713c-219.028 0-398.507 182.354-414.671 413.777-1.288 18.442 13.449 34.068 31.935 34.068h765.471c18.487 0 33.223-15.627 31.935-34.068-16.164-231.422-195.643-413.777-414.67-413.777z"/>'
  }
})
